var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0405 15.7031H23.0324C21.0903 15.7031 19.2276 16.474 17.8534 17.8463C16.4791 19.2187 15.7058 21.0804 15.7032 23.0225V69.9614C15.6993 70.9264 15.886 71.8826 16.2526 72.7753C16.6191 73.6679 17.1584 74.4794 17.8394 75.1631C18.5203 75.8469 19.3296 76.3894 20.2208 76.7596C21.112 77.1297 22.0675 77.3203 23.0324 77.3203H70.0405C71.0046 77.319 71.9591 77.1275 72.8491 76.7567C73.7391 76.386 74.5472 75.8432 75.2272 75.1596C75.9071 74.476 76.4454 73.665 76.8114 72.773C77.1774 71.881 77.3638 70.9255 77.3599 69.9614V23.0225C77.3572 21.0821 76.5853 19.2219 75.2132 17.8498C73.8411 16.4777 71.9809 15.7057 70.0405 15.7031ZM42.294 60.0837C42.2927 60.4062 42.2277 60.7253 42.1028 61.0227C41.9779 61.32 41.7955 61.5898 41.566 61.8165C41.3366 62.0432 41.0646 62.2223 40.7658 62.3436C40.4669 62.465 40.1471 62.5261 39.8246 62.5235H29.5517C28.9064 62.5209 28.2883 62.2627 27.8329 61.8054C27.3775 61.3481 27.1218 60.729 27.1218 60.0837V29.5122C27.1218 28.8668 27.3775 28.2477 27.8329 27.7905C28.2883 27.3332 28.9064 27.075 29.5517 27.0724H39.8246C40.4708 27.075 41.0899 27.3329 41.5469 27.7898C42.0039 28.2468 42.2617 28.8659 42.2643 29.5122L42.294 60.0837ZM66.0005 46.0475C66.0005 46.3704 65.9364 46.6901 65.812 46.988C65.6875 47.286 65.5051 47.5563 65.2754 47.7832C65.0457 48.0102 64.7733 48.1893 64.4738 48.3101C64.1744 48.431 63.8539 48.4912 63.5311 48.4872H53.2582C52.612 48.4846 51.9929 48.2268 51.5359 47.7698C51.0789 47.3128 50.821 46.6937 50.8184 46.0475V29.5122C50.821 28.8659 51.0789 28.2468 51.5359 27.7898C51.9929 27.3329 52.612 27.075 53.2582 27.0724H63.5311C64.1764 27.075 64.7945 27.3332 65.2499 27.7905C65.7053 28.2477 65.961 28.8668 65.961 29.5122L66.0005 46.0475Z",
    fill: "url(#paint0_linear_5972_11629)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5972_11629",
    x1: 9616.49,
    y1: 3924.7,
    x2: 9616.49,
    y2: 15.7031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/trello.99344d1835c3383c25584afadc19907e.svg";
export { ForwardRef as ReactComponent };